import { useState, useEffect } from "react";
import { compose } from "redux";
import { UsersOverviewConnector } from "../../../../services/users/connectors/Users.Overview.Connector";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";

const InvestorTag = ({
  currentUser,
  setTagForInvestor,
  getInvestorTags,
  users: { investorTags },
}) => {
  const [investorTag, changeTagForInvestor] = useState(
    currentUser.SegmentationTag,
  );
  useEffect(() => {
    if (investorTags.data === null) getInvestorTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!investorTags.fetched || investorTags.fetching) {
    return <div style={{ marginTop: "24px" }}>Loading...</div>;
  }

  return (
    <div style={{ marginTop: "24px" }}>
      <TextField
        size="small"
        variant="outlined"
        select
        label="Investor tag"
        menuItemStyle={{ color: "#000000" }}
        onChange={_change}
        value={investorTag}
      >
        {investorTags.data.map((item) => {
          return (
            <MenuItem key={item.Type} value={item.Type}>
              {item.Type}
            </MenuItem>
          );
        })}
      </TextField>
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => setTagForInvestor(investorTag, currentUser.Id)}
      >
        Set tag for investor
      </Button>
    </div>
  );

  function _change(e) {
    changeTagForInvestor(e.target.value);
  }
};
export default compose(UsersOverviewConnector)(InvestorTag);
